var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { transliterate } from "transliteration";
var LANGUAGE_FLAG_URL = "https://purecatamphetamine.github.io";
export function getLocalizedValue(lng, translations, onlyExactLanguageMatch) {
    try {
        var translated = translations === null || translations === void 0 ? void 0 : translations[lng];
        if (translated)
            return translated;
        if (onlyExactLanguageMatch)
            return;
        return Object.values(translations || []).find(Boolean) || undefined;
    }
    catch (e) {
        return '';
    }
}
export function getIconForLanguage(language) {
    if (!language)
        return undefined;
    var raw = language.trim().toLowerCase();
    var mapped = languageToCountry[raw];
    if (mapped)
        return "".concat(LANGUAGE_FLAG_URL, "/country-flag-icons/3x2/").concat(mapped, ".svg");
    if (raw.length === 2)
        return "".concat(LANGUAGE_FLAG_URL, "/country-flag-icons/3x2/").concat(raw.toUpperCase(), ".svg");
    var parts = raw.split(/[-_]/);
    if (parts.length === 2 && parts[1].length === 2)
        return "".concat(LANGUAGE_FLAG_URL, "/country-flag-icons/3x2/").concat(parts[1].toUpperCase(), ".svg");
    return undefined;
}
export function getIconForNationality(nationality) {
    if (!nationality)
        return undefined;
    return "".concat(LANGUAGE_FLAG_URL, "/country-flag-icons/3x2/").concat(nationality.toUpperCase(), ".svg");
}
export function getLocalizedLangLabel(langCode, userLanguage) {
    var _a, _b;
    var ui = (userLanguage || '').toLowerCase().slice(0, 2); // "de", "it", "en"
    var iso = ISO_LANGS.find(function (l) { return l.code === (langCode === null || langCode === void 0 ? void 0 : langCode.toLowerCase()); });
    if (!iso)
        return langCode;
    if (ui === 'de' && ((_a = iso.local) === null || _a === void 0 ? void 0 : _a.de))
        return iso.local.de;
    if (ui === 'it' && ((_b = iso.local) === null || _b === void 0 ? void 0 : _b.it))
        return iso.local.it;
    return iso.name || langCode;
}
export function getShortLocalizedLang(langCode, userLanguage) {
    return getLocalizedLangLabel(langCode, userLanguage).slice(0, 3);
}
// Language exception section
var LANGUAGE_EXCEPTIONS = {
    'de': 'D',
    'en': 'E',
};
var EXCEPTION_LABELS = {
    'D': 'Deutsch (German) - Special code: D',
    'E': 'English - Special code: E',
};
export var getLanguageLabel = function (option, getNameForLanguage) {
    return EXCEPTION_LABELS[option] || getNameForLanguage(option) || '';
};
export var processLanguageExceptions = function (value) {
    var result = __spreadArray([], value, true);
    Object.entries(LANGUAGE_EXCEPTIONS).forEach(function (_a) {
        var parent = _a[0], exception = _a[1];
        if (result.includes(parent) && !result.includes(exception)) {
            result.push(exception);
        }
    });
    return result;
};
export var handleExceptionRemoval = function (prevIds, newValue) {
    var value = __spreadArray([], newValue, true);
    Object.entries(LANGUAGE_EXCEPTIONS).forEach(function (_a) {
        var parent = _a[0], exception = _a[1];
        // User removed the exception -> remove parent too
        if (prevIds.includes(parent) && prevIds.includes(exception) && !value.includes(exception)) {
            value = value.filter(function (v) { return v !== parent; });
        }
        // User removed the parent -> remove exception too
        if (prevIds.includes(parent) && prevIds.includes(exception) && !value.includes(parent)) {
            value = value.filter(function (v) { return v !== exception; });
        }
    });
    return processLanguageExceptions(value);
};
export function getNameForLanguage(language, fallbackToCode, onlyNativeName) {
    var isoLang = ISO_LANGS.find(function (l) { return l.code === (language === null || language === void 0 ? void 0 : language.toLowerCase()) || l.native === language || l.native === language; });
    if (isoLang && (isoLang.native || isoLang.name)) {
        var parts = [];
        if (isoLang.native) {
            parts.push(isoLang.native);
        }
        if (!onlyNativeName && isoLang.name && isoLang.name != isoLang.native) {
            parts.push("(".concat(isoLang.name, ")"));
        }
        return parts.join(' ');
    }
    return fallbackToCode ? language : undefined;
}
export function translateToAscii(text) {
    if (!text)
        return '';
    return transliterate(text);
}
export function getNameForMaileonLanguage(language, onlyNativeName) {
    var lowerLang = language ? language.toLowerCase() : null;
    // Try to find the language within the maileon languages
    var maileonLang = MAILEON_LANGS.find(function (l) {
        return l.code === lowerLang ||
            l.native === language ||
            l.name === language;
    });
    // If not found, set the first language as default
    var lang = maileonLang || MAILEON_LANGS[0];
    var parts = [];
    if (lang.native) {
        parts.push(lang.native);
    }
    if (!onlyNativeName && lang.name && lang.name !== lang.native) {
        parts.push("(".concat(lang.name, ")"));
    }
    return parts.join(' ');
}
export function getMaileonLangCode(langCode) {
    var _a;
    return ((_a = MAILEON_LANGS.find(function (ml) { return ml.code === langCode; })) === null || _a === void 0 ? void 0 : _a.code) || MAILEON_LANGS[0].code;
}
export var getLanuageISO2Codes = function () {
    return ISO_LANGS.map(function (l) { return l.code; });
};
export var ISO_LANGS = [
    {
        name: "Afrikaans",
        code: "af",
        native: "Afrikaans",
        local: { de: "Afrikaans", it: "afrikaans" }
    },
    {
        name: "Albanian",
        code: "sq",
        native: "Shqip",
        local: { de: "Albanisch", it: "albanese" }
    },
    {
        name: "Amharic",
        code: "am",
        native: "አማርኛ",
        local: { de: "Amharisch", it: "amarico" }
    },
    {
        name: "Arabic",
        code: "ar",
        native: "العربية",
        local: { de: "Arabisch", it: "arabo" }
    },
    {
        name: "Armenian",
        code: "hy",
        native: "Հայերեն",
        local: { de: "Armenisch", it: "armeno" }
    },
    {
        name: "Azeerbaijani",
        code: "az",
        native: "azərbaycan dili",
        local: { de: "Aserbaidschanisch", it: "azero" }
    },
    {
        name: "Basque",
        code: "eu",
        native: "euskara",
        local: { de: "Baskisch", it: "basco" }
    },
    {
        name: "Belarusian",
        code: "be",
        native: "беларуская мова",
        local: { de: "Belarussisch", it: "bielorusso" }
    },
    {
        name: "Bengali",
        code: "bn",
        native: "বাংলা",
        local: { de: "Bengalisch", it: "bengalese" }
    },
    {
        name: "Bosnian",
        code: "bs",
        native: "bosanski jezik",
        local: { de: "Bosnisch", it: "bosniaco" }
    },
    {
        name: "Bulgarian",
        code: "bg",
        native: "български език",
        local: { de: "Bulgarisch", it: "bulgaro" }
    },
    {
        name: "Catalan",
        code: "ca",
        native: "català",
        local: { de: "Katalanisch", it: "catalano" }
    },
    {
        name: "Cebuano",
        code: "ceb",
        native: "Cebuano",
        local: { de: "Cebuano", it: "cebuano" }
    },
    {
        name: "Chinese",
        code: "zh",
        native: "中文",
        local: { de: "Chinesisch", it: "cinese" }
    },
    {
        name: "Corsican",
        code: "co",
        native: "corsu",
        local: { de: "Korsisch", it: "corso" }
    },
    {
        name: "Croatian",
        code: "hr",
        native: "hrvatski jezik",
        local: { de: "Kroatisch", it: "croato" }
    },
    {
        name: "Czech",
        code: "cs",
        native: "čeština",
        local: { de: "Tschechisch", it: "ceco" }
    },
    {
        name: "Danish",
        code: "da",
        native: "dansk",
        local: { de: "Dänisch", it: "danese" }
    },
    {
        name: "Dutch",
        code: "nl",
        native: "Nederlands",
        local: { de: "Niederländisch", it: "olandese" }
    },
    {
        name: "English",
        code: "en",
        native: "English",
        local: { de: "Englisch", it: "inglese" }
    },
    {
        name: "Esperanto",
        code: "eo",
        native: "Esperanto",
        local: { de: "Esperanto", it: "esperanto" }
    },
    {
        name: "Estonian",
        code: "et",
        native: "eesti",
        local: { de: "Estnisch", it: "estone" }
    },
    {
        name: "Finnish",
        code: "fi",
        native: "suomi",
        local: { de: "Finnisch", it: "finlandese" }
    },
    {
        name: "French",
        code: "fr",
        native: "français",
        local: { de: "Französisch", it: "francese" }
    },
    {
        name: "Frisian",
        code: "fy",
        native: "Frysk",
        local: { de: "Friesisch", it: "frisone" }
    },
    {
        name: "Galician",
        code: "gl",
        native: "Galego",
        local: { de: "Galicisch", it: "galiziano" }
    },
    {
        name: "Georgian",
        code: "ka",
        native: "ქართული",
        local: { de: "Georgisch", it: "georgiano" }
    },
    {
        name: "German",
        code: "de",
        native: "Deutsch",
        local: { de: "Deutsch", it: "tedesco" }
    },
    {
        name: "Greek",
        code: "el",
        native: "ελληνικά",
        local: { de: "Griechisch", it: "greco" }
    },
    {
        name: "Gujarati",
        code: "gu",
        native: "ગુજરાતી",
        local: { de: "Gujarati", it: "gujarati" }
    },
    {
        name: "Haitian Creole",
        code: "ht",
        native: "Kreyòl ayisyen",
        local: { de: "Haitianisch (Kreolisch)", it: "creolo haitiano" }
    },
    {
        name: "Hausa",
        code: "ha",
        native: "هَوُسَ",
        local: { de: "Hausa", it: "hausa" }
    },
    {
        name: "Hawaiian",
        code: "haw",
        native: "ʻŌlelo Hawaiʻi",
        local: { de: "Hawaiisch", it: "hawaiano" }
    },
    {
        name: "Hebrew",
        code: "iw",
        native: "עברית",
        local: { de: "Hebräisch", it: "ebraico" }
    },
    {
        name: "Hindi",
        code: "hi",
        native: "हिन्दी, हिंदी",
        local: { de: "Hindi", it: "hindi" }
    },
    {
        name: "Hmong",
        code: "hmn",
        native: "Hmoob",
        local: { de: "Hmong", it: "hmong" }
    },
    {
        name: "Hungarian",
        code: "hu",
        native: "magyar",
        local: { de: "Ungarisch", it: "ungherese" }
    },
    {
        name: "Icelandic",
        code: "is",
        native: "Íslenska",
        local: { de: "Isländisch", it: "islandese" }
    },
    {
        name: "Igbo",
        code: "ig",
        native: "Asụsụ Igbo",
        local: { de: "Igbo", it: "igbo" }
    },
    {
        name: "Indonesian",
        code: "id",
        native: "Bahasa Indonesia",
        local: { de: "Indonesisch", it: "indonesiano" }
    },
    {
        name: "Irish",
        code: "ga",
        native: "Gaeilge",
        local: { de: "Irisch", it: "irlandese" }
    },
    {
        name: "Italian",
        code: "it",
        native: "Italiano",
        local: { de: "Italienisch", it: "italiano" }
    },
    {
        name: "Japanese",
        code: "ja",
        native: "日本語",
        local: { de: "Japanisch", it: "giapponese" }
    },
    {
        name: "Javanese",
        code: "jw",
        native: "Basa Jawa",
        local: { de: "Javanisch", it: "giavanese" }
    },
    {
        name: "Kannada",
        code: "kn",
        native: "ಕನ್ನಡ",
        local: { de: "Kannada", it: "kannada" }
    },
    {
        name: "Kazakh",
        code: "kk",
        native: "қазақ тілі",
        local: { de: "Kasachisch", it: "kazako" }
    },
    {
        name: "Khmer",
        code: "km",
        native: "ខ្មែរ, ខេមរភាសា, ភាសាខ្មែរ",
        local: { de: "Khmer", it: "khmer" }
    },
    {
        name: "Korean",
        code: "ko",
        native: "한국어",
        local: { de: "Koreanisch", it: "coreano" }
    },
    {
        name: "Kurdish",
        code: "ku",
        native: "Kurdî",
        local: { de: "Kurdisch", it: "curdo" }
    },
    {
        name: "Kyrgyz",
        code: "ky",
        native: "Кыргызча",
        local: { de: "Kirgisisch", it: "kirghiso" }
    },
    {
        name: "Lao",
        code: "lo",
        native: "ພາສາລາວ",
        local: { de: "Laotisch", it: "lao" }
    },
    {
        name: "Latin",
        code: "la",
        native: "latine",
        local: { de: "Latein", it: "latino" }
    },
    {
        name: "Latvian",
        code: "lv",
        native: "Latviešu",
        local: { de: "Lettisch", it: "lettone" }
    },
    {
        name: "Lithuanian",
        code: "lt",
        native: "lietuvių kalba",
        local: { de: "Litauisch", it: "lituano" }
    },
    {
        name: "Luxembourgish",
        code: "lb",
        native: "Lëtzebuergesch",
        local: { de: "Luxemburgisch", it: "lussemburghese" }
    },
    {
        name: "Macedonian",
        code: "mk",
        native: "македонски јазик",
        local: { de: "Mazedonisch", it: "macedone" }
    },
    {
        name: "Malagasy",
        code: "mg",
        native: "fiteny malagasy",
        local: { de: "Malagasy", it: "malgascio" }
    },
    {
        name: "Malay",
        code: "ms",
        native: "بهاس ملايو",
        local: { de: "Malaiisch", it: "malese" }
    },
    {
        name: "Malayalam",
        code: "ml",
        native: "മലയാളം",
        local: { de: "Malaiisch (Malayalam)", it: "malayalam" }
    },
    {
        name: "Maltese",
        code: "mt",
        native: "Malti",
        local: { de: "Maltesisch", it: "maltese" }
    },
    {
        name: "Maori",
        code: "mi",
        native: "te reo Māori",
        local: { de: "Māori", it: "maori" }
    },
    {
        name: "Marathi",
        code: "mr",
        native: "मराठी",
        local: { de: "Marathi", it: "marathi" }
    },
    {
        name: "Mongolian",
        code: "mn",
        native: "Монгол хэл",
        local: { de: "Mongolisch", it: "mongolo" }
    },
    {
        name: "Myanmar",
        code: "my",
        native: "ဗမာစာ",
        local: { de: "Birmanisch", it: "birmano (Myanmar)" }
    },
    {
        name: "Nepali",
        code: "ne",
        native: "नेपाली",
        local: { de: "Nepalesisch", it: "nepalese" }
    },
    {
        name: "Norwegian",
        code: "no",
        native: "Norsk",
        local: { de: "Norwegisch", it: "norvegese" }
    },
    {
        name: "Nyanja",
        code: "ny",
        native: "chinyanja",
        local: { de: "Nyanja", it: "nyanja" }
    },
    {
        name: "Pashto",
        code: "ps",
        native: "پښتو",
        local: { de: "Paschtu", it: "pashto" }
    },
    {
        name: "Persian",
        code: "fa",
        native: "فارسی",
        local: { de: "Persisch", it: "persiano" }
    },
    {
        name: "Polish",
        code: "pl",
        native: "język polski",
        local: { de: "Polnisch", it: "polacco" }
    },
    {
        name: "Portuguese",
        code: "pt",
        native: "Português",
        local: { de: "Portugiesisch", it: "portoghese" }
    },
    {
        name: "Punjabi",
        code: "pa",
        native: "ਪੰਜਾਬੀ",
        local: { de: "Pandschabi", it: "punjabi" }
    },
    {
        name: "Romanian",
        code: "ro",
        native: "Română",
        local: { de: "Rumänisch", it: "rumeno" }
    },
    {
        name: "Russian",
        code: "ru",
        native: "Русский",
        local: { de: "Russisch", it: "russo" }
    },
    {
        name: "Samoan",
        code: "sm",
        native: "gagana fa'a Samoa",
        local: { de: "Samoanisch", it: "samoano" }
    },
    {
        name: "Scots Gaelic",
        code: "gd",
        native: "Gàidhlig",
        local: { de: "Schottisch-Gälisch", it: "gaelico scozzese" }
    },
    {
        name: "Serbian",
        code: "sr",
        native: "Srpski",
        local: { de: "Serbisch", it: "serbo" }
    },
    {
        name: "Sesotho",
        code: "st",
        native: "Sesotho",
        local: { de: "Sotho (Süd)", it: "sotho meridionale" }
    },
    {
        name: "Shona",
        code: "sn",
        native: "chiShona",
        local: { de: "Shona", it: "shona" }
    },
    {
        name: "Sindhi",
        code: "sd",
        native: "सिन्धी",
        local: { de: "Sindhi", it: "sindhi" }
    },
    {
        name: "Sinhala",
        code: "si",
        native: "සිංහල",
        local: { de: "Singhalesisch", it: "cingalese" }
    },
    {
        name: "Slovak",
        code: "sk",
        native: "Slovenčina",
        local: { de: "Slowakisch", it: "slovacco" }
    },
    {
        name: "Slovenian",
        code: "sl",
        native: "Slovenski Jezik",
        local: { de: "Slowenisch", it: "sloveno" }
    },
    {
        name: "Somali",
        code: "so",
        native: "Soomaaliga",
        local: { de: "Somali", it: "somalo" }
    },
    {
        name: "Spanish",
        code: "es",
        native: "Español",
        local: { de: "Spanisch", it: "spagnolo" }
    },
    {
        name: "Sundanese",
        code: "su",
        native: "Basa Sunda",
        local: { de: "Sundanesisch", it: "sundanese" }
    },
    {
        name: "Swahili",
        code: "sw",
        native: "Kiswahili",
        local: { de: "Swahili", it: "swahili" }
    },
    {
        name: "Swedish",
        code: "sv",
        native: "Svenska",
        local: { de: "Schwedisch", it: "svedese" }
    },
    {
        name: "Tagalog",
        code: "tl",
        native: "Wikang Tagalog",
        local: { de: "Tagalog", it: "tagalog" }
    },
    {
        name: "Tajik",
        code: "tg",
        native: "тоҷикӣ",
        local: { de: "Tadschikisch", it: "tagico" }
    },
    {
        name: "Tamil",
        code: "ta",
        native: "தமிழ்",
        local: { de: "Tamil", it: "tamil" }
    },
    {
        name: "Telugu",
        code: "te",
        native: "తెలుగు",
        local: { de: "Telugu", it: "telugu" }
    },
    {
        name: "Thai",
        code: "th",
        native: "ไทย",
        local: { de: "Thailändisch", it: "thailandese" }
    },
    {
        name: "Turkish",
        code: "tr",
        native: "Türkçe",
        local: { de: "Türkisch", it: "turco" }
    },
    {
        name: "Ukrainian",
        code: "uk",
        native: "Українська",
        local: { de: "Ukrainisch", it: "ucraino" }
    },
    {
        name: "Urdu",
        code: "ur",
        native: "اردو",
        local: { de: "Urdu", it: "urdu" }
    },
    {
        name: "Uzbek",
        code: "uz",
        native: "Ўзбек",
        local: { de: "Usbekisch", it: "uzbeko" }
    },
    {
        name: "Vietnamese",
        code: "vi",
        native: "Tiếng Việt",
        local: { de: "Vietnamesisch", it: "vietnamita" }
    },
    {
        name: "Welsh",
        code: "cy",
        native: "Cymraeg",
        local: { de: "Walisisch", it: "gallese" }
    },
    {
        name: "Xhosa",
        code: "xh",
        native: "isiXhosa",
        local: { de: "Xhosa", it: "xhosa" }
    },
    {
        name: "Yiddish",
        code: "yi",
        native: "ייִדיש",
        local: { de: "Jiddisch", it: "yiddish" }
    },
    {
        name: "Yoruba",
        code: "yo",
        native: "Yorùbá",
        local: { de: "Yoruba", it: "yoruba" }
    },
    {
        name: "Zulu",
        code: "zu",
        native: "isiZulu",
        local: { de: "Zulu", it: "zulu" }
    }
];
export var languageToCountry = {
    aa: 'ET',
    ab: 'GE',
    af: 'ZA',
    ak: 'GH',
    am: 'ET',
    ar: 'SA',
    as: 'IN',
    ay: 'BO',
    az: 'AZ',
    ba: 'RU',
    be: 'BY',
    bg: 'BG',
    bh: 'IN',
    bi: 'VU',
    bn: 'BD',
    bo: 'CN',
    br: 'FR',
    bs: 'BA',
    ca: 'ES',
    ce: 'RU',
    ch: 'GU',
    co: 'FR',
    cs: 'CZ',
    cv: 'RU',
    cy: 'GB',
    da: 'DK',
    de: 'DE',
    dv: 'MV',
    dz: 'BT',
    ee: 'GH',
    el: 'GR',
    en: 'GB',
    eo: 'INT',
    es: 'ES',
    et: 'EE',
    eu: 'ES',
    fa: 'IR',
    ff: 'SN',
    fi: 'FI',
    fj: 'FJ',
    fo: 'FO',
    fr: 'FR',
    fy: 'NL',
    ga: 'IE',
    gd: 'GB',
    gl: 'ES',
    gn: 'PY',
    gu: 'IN',
    gv: 'IM',
    ha: 'NG',
    he: 'IL',
    hi: 'IN',
    ho: 'PG',
    hr: 'HR',
    ht: 'HT',
    hu: 'HU',
    hy: 'AM',
    hz: 'NA',
    ia: 'INT',
    id: 'ID',
    ie: 'INT',
    ig: 'NG',
    ii: 'CN',
    ik: 'US',
    io: 'INT',
    is: 'IS',
    it: 'IT',
    iu: 'CA',
    ja: 'JP',
    jv: 'ID',
    ka: 'GE',
    kg: 'CD',
    ki: 'KE',
    kj: 'NA',
    kk: 'KZ',
    kl: 'GL',
    km: 'KH',
    kn: 'IN',
    ko: 'KR',
    kr: 'NG',
    ks: 'IN',
    ku: 'IQ',
    kv: 'RU',
    kw: 'GB',
    ky: 'KG',
    la: 'VA',
    lb: 'LU',
    lg: 'UG',
    li: 'NL',
    ln: 'CD',
    lo: 'LA',
    lt: 'LT',
    lu: 'CD',
    lv: 'LV',
    mg: 'MG',
    mh: 'MH',
    mi: 'NZ',
    mk: 'MK',
    ml: 'IN',
    mn: 'MN',
    mr: 'IN',
    ms: 'MY',
    mt: 'MT',
    my: 'MM',
    na: 'NR',
    nb: 'NO',
    nd: 'ZW',
    ne: 'NP',
    ng: 'NA',
    nl: 'NL',
    nn: 'NO',
    no: 'NO',
    nr: 'ZA',
    nv: 'US',
    ny: 'MW',
    oc: 'FR',
    oj: 'CA',
    om: 'ET',
    or: 'IN',
    os: 'GE',
    pa: 'IN',
    pi: 'IN',
    pl: 'PL',
    ps: 'AF',
    pt: 'PT',
    qu: 'PE',
    rm: 'CH',
    rn: 'BI',
    ro: 'RO',
    ru: 'RU',
    rw: 'RW',
    sa: 'IN',
    sc: 'IT',
    sd: 'PK',
    se: 'NO',
    sg: 'CF',
    si: 'LK',
    sk: 'SK',
    sl: 'SI',
    sm: 'WS',
    sn: 'ZW',
    so: 'SO',
    sq: 'AL',
    sr: 'RS',
    ss: 'SZ',
    st: 'LS',
    su: 'ID',
    sv: 'SE',
    sw: 'TZ',
    ta: 'IN',
    te: 'IN',
    tg: 'TJ',
    th: 'TH',
    ti: 'ET',
    tk: 'TM',
    tl: 'PH',
    tn: 'BW',
    to: 'TO',
    tr: 'TR',
    ts: 'ZA',
    tt: 'RU',
    tw: 'GH',
    ty: 'PF',
    ug: 'CN',
    uk: 'UA',
    ur: 'PK',
    uz: 'UZ',
    ve: 'ZA',
    vi: 'VN',
    vo: 'INT',
    wa: 'BE',
    wo: 'SN',
    xh: 'ZA',
    yi: 'IL',
    yo: 'NG',
    za: 'CN',
    zh: 'CN',
    zu: 'ZA', // Zulu -> South Africa
};
export var MAILEON_LANGS = [
    {
        "code": "de",
        "name": "German",
        "native": "Deutsch"
    },
    {
        "code": "en",
        "name": "English",
        "native": "English"
    },
    {
        "code": "es",
        "name": "Castellano",
        "native": "Español"
    },
    {
        "code": "fr",
        "name": "French",
        "native": "français"
    },
    {
        "code": "it",
        "name": "Italian",
        "native": "Italiano"
    },
    {
        "code": "ru",
        "name": "Russian",
        "native": "Русский"
    },
    {
        "code": "hu",
        "name": "Hungarian",
        "native": "magyar"
    },
    {
        "code": "pl",
        "name": "Polish",
        "native": "język polski"
    },
    {
        "code": "cs",
        "name": "Czech",
        "native": "čeština"
    },
    {
        "code": "tr",
        "name": "Turkish",
        "native": "Türkçe"
    },
    /*
        Croatian and Ukrainian are officially supported by Maileon, according to their documentation
        But in practice, they are not working when being passed to the API
        TODO - Ask Maileon support about this
    */
    // {
    //     "code": "hr",
    //     "name": "Croatian",
    //     "native": "hrvatski jezik"
    // },
    // {
    //     "code": "uk",
    //     "name": "Ukranian",
    //     "native": "Українська"
    // },
    {
        "code": "nl",
        "name": "Dutch",
        "native": "Nederlands"
    },
];
